import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { getTrialMessaging } from './getTrialMessaging';
const SpecificMessaging = new Map([[Flow.Trial, getTrialMessaging]]);
export const getSpecificMessagingFunction = () => {
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  return integrationKey && SpecificMessaging.get(integrationKey) || SpecificMessaging.get(flowKey);
};